import type { CurvaDocument } from "@/document/model/document";
import {
  cloneScriptEntryWithFreshIds,
  cloneScriptLibraryWithFreshIds,
  createScriptFolder,
  listDocumentScripts,
  uniqueFolderName,
  type ScriptFolder,
  type ScriptLibrary,
} from "@/document/model/documentScripts";

export interface PreparedScriptImport {
  folder: ScriptFolder;
  scriptCount: number;
}

/** Wrap the imported library (fresh ids) in a new top-level folder named after the source file. */
export function prepareScriptImport(
  currentDocument: CurvaDocument,
  importedDocument: CurvaDocument,
  folderBaseName: string,
): PreparedScriptImport | undefined {
  const importedScripts = listDocumentScripts(importedDocument.scripts);
  if (importedScripts.length === 0) {
    return undefined;
  }

  const library = currentDocument.scripts ?? { items: [] };
  const folder = createScriptFolder(uniqueFolderName(library, folderBaseName));
  folder.children = (importedDocument.scripts?.items ?? []).map(cloneScriptEntryWithFreshIds);
  return {
    folder,
    scriptCount: importedScripts.length,
  };
}

/** Full library replacement: imported tree with fresh ids (no wrapping folder). */
export function prepareScriptLibraryReplace(importedDocument: CurvaDocument): ScriptLibrary | undefined {
  const importedScripts = listDocumentScripts(importedDocument.scripts);
  if (importedScripts.length === 0) {
    return undefined;
  }
  return cloneScriptLibraryWithFreshIds(importedDocument.scripts);
}
